<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            <strong>Modifier les inforamtions du bénéficiaire</strong> 
          </div>
          
          <b-row class="form-group">
            <b-col md="6">
              <label for="num_transaction">Nom du bénéficiaire</label>
              <b-form-input id="nom_benef" type="text" v-model="retrait.nom_benef" placeholder="Nom" class="form-control" :disabled="success == true"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="code_envoie">Prénom(s) du bénéficiaire</label>
              <b-form-input id="prenom_benef" type="text" v-model="retrait.prenom_benef" placeholder="Prénom(s)"></b-form-input>
            </b-col>
            <b-col md="12">
              <label for="description">Motif</label>
               <textarea id="description" placeholder="Motif" v-model="retrait.motif" rows="3" max-rows="6" class="form-control"></textarea>
            </b-col>
          </b-row>
          <div slot="footer">
            <span><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Modifier</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>   
        <!--<b-card class="card-accent-info" header="INFORMATION SUR LE BENEFICIAIRE" v-if="success">
            <div class="bd-example">
              <dl class="row">
                  <dt class="col-sm-2">Nom</dt>
                  <dd class="col-sm-3"> {{retrait.nom}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Prénom(s)</dt>
                  <dd class="col-sm-3"> {{retrait.prenom}} </dd>
              </dl>
              <dl class="row">
                  <dt class="col-sm-2">Adresse</dt>
                  <dd class="col-sm-3"> {{retrait.adresse}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Téléphone</dt>
                  <dd class="col-sm-3"> {{retrait.telephone}} </dd>
              </dl>
              <dl class="row">
                  <dt class="col-sm-2">Montant</dt>
                  <dd class="col-sm-3"> {{retrait.montant_transfere}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Message</dt>
                  <dd class="col-sm-3"> {{message_retrait}} </dd>
              </dl>
            </div>
        </b-card>-->
        <!--<b-card>
          <div slot="header">
            Information sur le bénéficiaire <strong></strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="device">Nom Bénéficiaire</label>
              <b-form-input type="text" v-model="mandats.nom_benef" placeholder="Nom du bénéficiaire"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="solde">Prenom(s) Bénéficiaire</label>
              <b-form-input type="text" v-model="mandats.prenom_benef" placeholder="Prénom(s) du bénéficiaire"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="device">Téléphone Bénéficiaire</label>
              <b-form-input type="text" v-model="mandats.telephone_benef" placeholder="Téléphone du bénéficiaire"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="device">Adresse Bénéficiaire</label>
              <b-form-input type="text" v-model="mandats.adresse_benef" placeholder="Téléphone du bénéficiaire"></b-form-input>
            </b-col>
          </b-row>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            <b-button type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>-->    
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      success:false,
      options : [],
      options_typepiece : [],
      options_typeoperation : [],
      message_retrait:"",
      piece_libelle:"",
      retrait:{
        id: "",
        nom_benef: "",
        prenom_benef: "",
        motif: "",
         _method:'PUT'
       
      },
      exist_num:true,
      atm:[],
      typepiece:[],
      typeoperation:[],
      serverParams: {
          page:1,
          current_page: 1,
          paginate: 10
        }
    }
  },
  methods:{
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
        this.dismissCountDown = this.dismissSecs
    },
    goBack() {
        this.$router.go(-1)
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    // isexiste(){
    //   if(this.retrait.num_transaction!=""){
    //     console.log(this.retrait.num_transaction)
    //     this.exist_num = true
    //   }else{this.exist_num=false}
    // },
    async updateSolde(){
        let solde = await api.atm.get_auth_guichets(token)
        localStorage.setItem('solde', solde.data.data.solde)
    },
    async get_all_typepieces(){
          //this.typepiece = store.getters['typepiece/rows'];
          await this.$store.dispatch('typepiece/get_all_typepieces',this.serverParams).then(()=>{
            return this.typepiece =  store.getters['typepiece/rows'];
          })
          this.typepiece.forEach((element)=>{
              this.options_typepiece.push({
                value:element.libelle,
                text:element.libelle
              })
          })
    },
    async postmontant(){     

        let response = await this.$store.dispatch('mandate/getInfobyNumTrans',{num_transaction:this.retrait.num_transaction})     

        if(response.success==true){
          this.success=true
          this.retrait.adresse= response.data.adresse,
          this.retrait.num_transaction= this.retrait.num_transaction,
          this.retrait.commission= response.data.commission,
          this.retrait.date_operation= response.data.date_operation,
          this.retrait.deleted_at= response.data.deleted_at,
          this.retrait.guichet_id= response.data.guichet_id,
          this.retrait.id= response.data.id,
          this.retrait.montant_transfere= response.data.montant_transfere,
          this.retrait.montant_ttc= response.data.montant_ttc,
          this.retrait.nb_benef= response.data.nb_benef,
          this.retrait.nom= response.data.nom,
          this.retrait.num_piece= response.data.num_piece,
          //this.retrait.num_transaction= response.data.num_transaction,
          this.retrait.prenom= response.data.prenom,
          this.retrait.statut= response.data.statut,
          this.retrait.telephone= response.data.telephone,
          this.retrait.tva= response.data.tva,
          this.retrait.typeoperation_id= response.data.typeoperation_id,
          this.retrait.typepiece_id= response.data.typepiece_id,
          this.retrait.updated_at= response.data.updated_at,
          this.retrait.user_id= response.data.user_id
        }else{
          this.success=false
          this.response = response
          this.showAlert()
          //this.response.errors = ["a"]
          //console.log("ma response ",this.response)
        }
          this.message_retrait = response.message
    },
    async post(){
        this.response = await this.$store.dispatch('mandate/put_mandates',this.retrait)     
        this.showAlert()
    },
    async displayMandate(){
        let response = await this.$store.dispatch('mandate/get_mandate_by_id',this.$route.params.id_mandat)
        this.retrait.nom_benef= response.nom
        this.retrait.prenom_benef= response.prenom
        this.retrait.motif= response.motif
        this.retrait.id= this.$route.params.id_mandat
  },
    reset(){
        this.success = false
        this.retrait.code_envoie= "",
        this.piece_libelle= ""
        this.retrait.num_transaction= ""
        this.retrait.num_piece_benef= ""
    }
  },
  mounted(){
    this.displayMandate()
  }
}
</script>
